module.exports = __webpack_public_path__ + "img/27.0c22a88c.jpg";